import { Flex, Layout, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import c from './Catalog.module.scss';
import WithMainContainer from '@/components/layout';
import CatalogExplorerItem from '@/widgets/CatalogExplorerItem/CatalogExplorerItem';
import { useStores } from '@/utils/hooks/useStores';
import { QueryService } from 'tkmp-lib/src/services/QueryService';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import HeadService from '@/utils/services/HeadService';

export const getServerSideProps = async (context: any) => {
    const breadcrumbsDto = [
        {
            key: '/',
            title: 'Главная',
        },
        {
            key: '/catalog',
            title: 'Каталог',
        },
    ];

    const locale = QueryService.getLocale(context);

    const catalogsDto = await QueryService.request(
        `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${locale}/catalog/category/home`,
    );
    if (catalogsDto) {
        return {
            props: {
                catalogsDto: catalogsDto.inner,
                countProductsDto: catalogsDto?.inner?.length ?? 0,
                breadcrumbsDto,
            },
        };
    }

    return {
        props: {
            catalogsDto: [],
            countProductsDto: 0,
            breadcrumbsDto,
        },
    };
};

function BaseCatalog({ catalogsDto, countProductsDto, breadcrumbsDto }: any) {
    console.log(catalogsDto);
    const [catalogs, setCatalogs] = useState(catalogsDto);
    const [countProducts, setCountProducts] = useState<number>(countProductsDto);
    const LOCALIZATION = useLocalization();
    const {
        systemStore: { setBreadcrumbs },
    } = useStores();

    useEffect(() => {
        setBreadcrumbs([
            {
                key: '/',
                title: LOCALIZATION.routes.home,
            },
            {
                key: '/catalog',
                title: LOCALIZATION.routes.catalog,
            },
        ]);
    }, [LOCALIZATION.locale]);

    return (
        <>
            {process.env.NEXT_PUBLIC_INCLUDE_SEO_TAGS === 'true' &&
                HeadService.simpleBuild('Каталог TKMP.Istok', '/catalog')}
            <Flex
                vertical
                className={c.body}
            >
                <Flex
                    className={c.body_header}
                    gap={'4px'}
                >
                    <Typography.Text className={`text-32-500`}>
                        {LOCALIZATION.pages.catalog.header.title}
                    </Typography.Text>
                    <Typography.Text className={`text-14-400 text-[#7B7C7D]`}>
                        {countProducts} {LOCALIZATION.pages.catalog.header.products}
                    </Typography.Text>
                </Flex>
                <Layout className={c.body_baseCatalogsGrid}>
                    {catalogs?.map((catalog: any, i: number) => (
                        <CatalogExplorerItem
                            key={i}
                            element={catalog}
                        />
                    ))}
                </Layout>
            </Flex>
        </>
    );
}

export default WithMainContainer(BaseCatalog);
